import React from "react";

export const MobileHorizontalRule = () => {
	return (
		<div className="lg:hidden">
			<hr className="bg-hr -mx-5 mb-[-1px]" />
			<hr className="border-charcoal mb-6 border-t" />
		</div>
	);
};

export const DesktopHorizontalRule = () => {
	return (
		<>
			<hr className="bg-hr to-lg:hidden -z-10 w-screen" />
			<div className="to-lg:hidden container">
				<hr className="border-charcoal mt-[-1px] border-t" />
			</div>
		</>
	);
};
